export default {
  increment (state) {
    state.reload = true
  },
  decrement (state) {
    state.reload = false
  },
  MUT_CUR (state, a) {
    state.cur = a
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js